module.exports = __webpack_public_path__ + "media/landing_work/home/images/total-trust-3994a73eefccd373cc86bd4010b988d7.jpg";